import { t } from "@lingui/macro";
import React from "react";
import InformationPill from "~/applications/OfferSearch/Ui/OfferDetails/InformationPill";
import { Couch } from "~/guidelines/Icon";
import ListItemWithIcon from "~/guidelines/ListItemWithIcon";

export type KitchenAndCouchAmenityProps = {
  variant?: "list-item" | "pill";
  hasKitchen: boolean;
  hasConvertibleCouch: boolean;
};

const KitchenAndCouchAmenity = ({
  variant = "list-item",
  hasKitchen,
  hasConvertibleCouch,
}: KitchenAndCouchAmenityProps) => {
  let textChildren: string | null = null;
  switch (true) {
    case hasKitchen && hasConvertibleCouch:
      textChildren = t`kitchen` + " + " + t`sofa bed`;
      break;
    case hasKitchen:
      textChildren = t`kitchen`;
      break;
    case hasConvertibleCouch:
      textChildren = t`sofa bed`;
      break;
    default:
      textChildren = null;
  }

  if (textChildren === null) {
    return null;
  }

  if (variant === "pill") {
    return <InformationPill icon={<Couch />} text={textChildren} />;
  }

  return <ListItemWithIcon icon={<Couch />}>{textChildren}</ListItemWithIcon>;
};

export default KitchenAndCouchAmenity;
